/*
	These functions make sure WordPress
	and Helios play nice together.
*/

jQuery(document).ready(function($) {
  /* Start: Variables - these are needed for all of the functions */

  const mobile_breakpoint = 999; // set to mobile breakpoint
  const helios_header = document.getElementById("header");
  const helios_content = document.getElementById("content");
  const helios_footer = document.getElementById("footer");
  const helios_admin_bar = document.getElementById("wpadminbar");
  const helios_3d_video = document.getElementById("main-3d-video");
  const analytics_debug = false;

  /* End: Variables */

  /* Start: Functions - these are helper functions needed for Helios */

  function is_fixed(elm) {
    let el;
    if (typeof elm === "object") el = elm[0] || elm;
    else if (typeof elm === "string") el = document.querySelector(elm);
    while (typeof el === "object" && el.nodeName.toLowerCase() !== "body") {
      if (
        window
          .getComputedStyle(el)
          .getPropertyValue("position")
          .toLowerCase() === "fixed"
      )
        return true;
      el = el.parentElement;
    }
    return false;
  }

  function set_cookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function get_cookie(cname) {
    let name = cname + "=";
    let decoded_cookie = decodeURIComponent(document.cookie);
    let ca = decoded_cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /* End: Functions */

  // Unwrap buttons (removing the p tags from the wp content editor)
  $(".column-block__content a.btn").each(function () {
    if (!$(this).hasClass("download")) {
      $(this).unwrap();
    }
  });

  /* Start: Adds Flex Video to YouTube and Vimeo Embeds */

  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
      $(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      $(this).wrap("<div class='responsive-embed'/>");
    }
  });

  /* End: Adds Flex Video to YouTube and Vimeo Embeds */

  /* Start: Sticky Footer */

  function helios_footer_position() {
    // Helios Announcement and Fixed Position Header
    if ($(helios_announcement).is(":visible") && is_fixed(helios_header)) {
      if (
        $(helios_announcement).outerHeight() +
          $(helios_content).outerHeight() +
          $(helios_footer).outerHeight() +
          $(helios_admin_bar).outerHeight() <
        window.innerHeight
      ) {
        // make footer absolute positioned
        $(helios_footer).removeClass("relative");
        $(helios_footer).addClass("absolute");
      } else {
        // make footer relative positioned
        $(helios_footer).removeClass("absolute");
        $(helios_footer).addClass("relative");
      }
      // Helios Announcement and Relative Position Header
    } else if ($(helios_announcement).is(":visible")) {
      if (
        $(helios_announcement).outerHeight() +
          $(helios_header).outerHeight() +
          $(helios_content).outerHeight() +
          $(helios_footer).outerHeight() +
          $(helios_admin_bar).outerHeight() <
        window.innerHeight
      ) {
        // make footer absolute positioned
        $(helios_footer).removeClass("relative");
        $(helios_footer).addClass("absolute");
      } else {
        // make footer relative positioned
        $(helios_footer).removeClass("absolute");
        $(helios_footer).addClass("relative");
      }
      // Fixed Position Header
    } else if (is_fixed(helios_header)) {
      if (
        $(helios_content).outerHeight() +
          $(helios_footer).outerHeight() +
          $(helios_admin_bar).outerHeight() <
        window.innerHeight
      ) {
        // make footer absolute positioned
        $(helios_footer).removeClass("relative");
        $(helios_footer).addClass("absolute");
      } else {
        // make footer relative positioned
        $(helios_footer).removeClass("absolute");
        $(helios_footer).addClass("relative");
      }
      // Relative Position Header
    } else {
      if (
        $(helios_header).outerHeight() +
          $(helios_content).outerHeight() +
          $(helios_footer).outerHeight() +
          $(helios_admin_bar).outerHeight() <
        window.innerHeight
      ) {
        // make footer absolute positioned
        $(helios_footer).removeClass("relative");
        $(helios_footer).addClass("absolute");
      } else {
        // make footer relative positioned
        $(helios_footer).removeClass("absolute");
        $(helios_footer).addClass("relative");
      }
    }
  }

  /* Function to add style element */
  function addStyle(styles) {
    /* Create style document */
    var css = document.createElement("style");
    css.type = "text/css";

    if (css.styleSheet) css.styleSheet.cssText = styles;
    else css.appendChild(document.createTextNode(styles));

    /* Append style to the tag name */
    document.getElementsByTagName("head")[0].appendChild(css);
  }

  setTimeout(function () {
    helios_footer_position();
  }, 250);

  let helios_footer_resize_timer;
  $(window).on("resize", function (e) {
    clearTimeout(helios_footer_resize_timer);
    helios_footer_resize_timer = setTimeout(function () {
      helios_footer_position();
    }, 250);
  });

  /* End: Sticky Footer */

  /* Start: Mobile Nav */

  function helios_mobile_nav() {
    if ($(window).width() <= mobile_breakpoint) {
      $(".hamburger").toggleClass("hamburger--open");
      $(".menu-container__nav--mobile ul.menu").toggleClass("mobile-menu-open");
      $(".menu-container__nav--mobile").slideToggle();
      $(".menu-container__nav--mobile ul.menu").css("opacity", 0);
      setTimeout(function () {
        $(".menu-container__nav--mobile .mobile-menu-open").css("opacity", 1);
      }, 250);
    } else {
      $(".hamburger").removeClass("hamburger--open");
      $(".menu-container__nav--mobile ul.menu").removeClass("mobile-menu-open");
      $(".menu-container__nav--mobile ul.menu").removeAttr("style");
      $(".menu-container__nav--mobile ul.menu").css("opacity", 1);
      $(".menu-container__nav--mobile").removeAttr("style");
    }
  }

  $(".menu-container__hamburger").on("click", function (e) {
    e.preventDefault();
    helios_mobile_nav();
  });

  let helios_mobile_nav_resize_timer;
  $(window).on("resize", function (e) {
    clearTimeout(helios_mobile_nav_resize_timer);
    helios_mobile_nav_resize_timer = setTimeout(function () {
      if ($(window).width() > mobile_breakpoint) {
        helios_mobile_nav();
      }
    }, 250);
  });

  /* End: Mobile Nav */

  /* Start: Modal */

  // If a modal exists on the page, append the overlay div to the body
  if ($(".helios-modal-wrapper").length) {
    $("body").append('<div class="helios-modal-overlay"></div>');
  }

  // Set modal container, used for click outside modal to close functionality
  let helios_modal_container = $(".helios-modal-container__inner");

  // set modal default z-index
  let helios_modal_zindex = 991;

  // open modal
  function helios_modal_enter(modal_id) {
    // fade the modal in and set the open class
    $(`#${modal_id}`).fadeIn();
    $(`#${modal_id}`).addClass("helios-modal-open");
    // always add to the z-index so if multiple modals are open they will stack based on most recent opened
    helios_modal_zindex = helios_modal_zindex + 1000;
    $(`#${modal_id}`).css("zIndex", helios_modal_zindex);
    $(`#${modal_id}`).attr("data-zindex", helios_modal_zindex);
    // only fade in the overlay once, check to see if multiple modals are open
    if ($(".helios-modal-open").length < 2) {
      $(".helios-modal-overlay").fadeIn(100);
    }

    // if this is the contact modal, load the iframe
    if (modal_id == "helios-modal-contact") {
      helios_modal_load_iframe(modal_id);
    }

    // grab media assets for display, this prevents images from loading when in the DOM by default
    helios_modal_load_featured(modal_id);

    // set all of the thumbnail background images when the modal is opened
    helios_modal_load_thumbnails(modal_id);

    // add event listeners - when a thumbnail is clicked, update the featured item and set the thumbnail to active
    helios_modal_event_listeners(modal_id);
  }

  // close modal
  function helios_modal_exit(modal_id) {
    $(`#${modal_id}`).fadeOut();
    setTimeout(function () {
      // reset the thumbnails
      helios_modal_reset(modal_id);
      if ($(".helios-modal-open").length > 1) {
        // if more than one modal is open, when closing the modal, remove it's helios-modal-open class
        $(`#${modal_id}`).removeClass("helios-modal-open");
      } else {
        // if only one modal is open, when closing the modal, remove it's helios-modal-open class and fade out the helios-modal-overlay, reset the modal z-index back to its default value 991.
        $(`#${modal_id}`).removeClass("helios-modal-open");
        $(".helios-modal-overlay").fadeOut(100);
        helios_modal_zindex = 991;
      }
      // remove the inline styles set on the modal when it was opened
      $(`#${modal_id}`).removeAttr("style");
      // remove zindex data attribute
      $(`#${modal_id}`).removeAttr("data-zindex");
    }, 400);
  }

  // if one of the menu items has the class btn-contact, add the class helios-modal so the link opens the contact modal
  if ($(".menu-item").hasClass("contact")) {
    $(".contact a").addClass("helios-modal menu-item-link");
    $(".contact a").attr("data-id", "helios-modal-contact");
  }

  // Solution for New Tab instead of Modal
  $(".menu-item").on("click", function () {
    let label, category;
    label = $(this).text();
    category = "Navigation";

    // gtag("event", "click", {
    //   event_category: `${category}`,
    //   event_label: `${label}`,
    // });
  });

  // if one of the menu items has the class press, add the class helios-modal so the link opens the press modal
  if ($(".menu-item").hasClass("press")) {
    $(".press a").addClass("helios-modal menu-item-link");
    $(".press a").attr("data-id", "helios-modal-press");
  }

  $(".helios-modal").on("click", function (e) {
    e.preventDefault();
    let modal_id = $(this).attr("data-id");
    let label, category;
    // when the user clicks links with the class helios-modal, get the data-id and open the modal that has the id
    helios_modal_enter(modal_id);
    // if there is only one modal open and the user is closing it, disable body scroll and set the lock
    if ($(".helios-modal-open").length < 2) {
      let targetElement = document.querySelector(`.${modal_id}__inner`);
      bodyScrollLock.disableBodyScroll(targetElement);
    }
    if ($(this).hasClass("menu-item-link")) {
      label = $(this).text();
      category = "Navigation";
    } else {
      label = $(this).data("analytics");
      category = "Hotspot";
    }
    // gtag("event", "click", {
    //   event_category: `${category}`,
    //   event_label: `${label}`,
    // });
  });

  $(".helios-modal-wrapper .helios-exit__btn").on("click", function (e) {
    e.preventDefault();
    let modal_id = $(this).parents(".helios-modal-wrapper").attr("id");
    // close the modal when the user clicks the exit button
    helios_modal_exit(modal_id);
    // if there is only one modal open and the user is closing it, release body scroll lock
    if ($(".helios-modal-open").length < 2) {
      let targetElement = document.querySelector(`.${modal_id}__inner`);
      bodyScrollLock.enableBodyScroll(targetElement);
    }
  });

  $(document).mouseup(function (e) {
    let container_header = $(".helios-modal-container__header");
    let container_content = $(".helios-modal-container__inner");
    // if the target of the click isn't the container nor a descendant of the container
    if (
      !$("#helios-modal-site-gate").hasClass("helios-modal-open") &&
      $(".helios-modal-wrapper").hasClass("helios-modal-open") &&
      !container_header.is(e.target) &&
      container_header.has(e.target).length === 0 &&
      !container_content.is(e.target) &&
      container_content.has(e.target).length === 0
    ) {
      if ($(".helios-modal-open").length > 1) {
        // close all modals that are open
        $(".helios-modal-open").each(function (i, obj) {
          helios_modal_exit($(this).attr("id"));
        });
      } else {
        // close the single modal that is open
        helios_modal_exit($(".helios-modal-open").attr("id"));
      }
      // release body scroll lock
      bodyScrollLock.clearAllBodyScrollLocks();
    }
  });

  $(document).keyup(function (e) {
    let container = $(".helios-modal-content");
    let helios_modal_open = $(".helios-modal-open").length;
    if (
      !$("#helios-modal-site-gate").hasClass("helios-modal-open") &&
      helios_modal_open
    ) {
      if (e.key === "Escape") {
        if (helios_modal_open > 1) {
          let helios_modal_open_zindex = 0;
          let helios_modal_open_zindex_attr = 0;
          let helios_modal_open_escaped = "";
          $(".helios-modal-open").each(function (i, obj) {
            helios_modal_open_zindex_attr = $(this).data("zindex");
            if (helios_modal_open_zindex_attr > helios_modal_open_zindex) {
              helios_modal_open_zindex = helios_modal_open_zindex_attr;
              helios_modal_open_escaped = $(this);
            }
          });
          helios_modal_open_escaped = helios_modal_open_escaped.get(0);
          helios_modal_exit($(helios_modal_open_escaped).attr("id"));
        } else {
          let modal_id = $(".helios-modal-open").attr("id");
          helios_modal_exit(modal_id);
          // release body scroll lock
          bodyScrollLock.clearAllBodyScrollLocks();
        }
      }
    }
  });

  // load the contact/press iframe
  function helios_modal_load_iframe(modal_id) {
    let iframe_src = $(`#${modal_id} iframe`).data("src");
    $(`#${modal_id} iframe`).attr("src", iframe_src);
  }

  // grab media assets for display, this prevents images from loading when in the DOM by default
  function helios_modal_load_featured(modal_id, item) {
    if (item) {
      // when a thumbnail is clicked, get the item type
      let thumbnail_item_type = $(item).attr("data-item-type");

      if (thumbnail_item_type == "video" && $(item).find("video").length) {
        if (videojs.players["featured-video"]) {
          videojs("featured-video").dispose();
        }

        $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video`
        ).attr("id", "featured-video");

        // if item type is video, get the poster and video source
        let featured_item_video_poster = $(item)
          .find("video")
          .attr("data-poster");

        // let featured_item_video_poster = $(item).attr('data-img');
        let featured_item_video_webm = $(item)
          .find(".column-block__media video source.webm")
          .attr("data-webm");
        let featured_item_video_mp4 = $(item)
          .find(".column-block__media video source.mp4")
          .attr("data-mp4");

        // if item type is video, set the poster and video source
        $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video`
        ).attr("poster", featured_item_video_poster);

        if (featured_item_video_webm) {
          $(
            `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video source.webm`
          ).attr("src", featured_item_video_webm);
        }
        if (featured_item_video_mp4) {
          $(
            `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video source.mp4`
          ).attr("src", featured_item_video_mp4);
        }

        var video_player = videojs("featured-video", {}, function () {
          // the third parameter is the ready event on the constructor
          this.on("ended", function () {
            let hotspot = $(`#${modal_id}.helios-modal-open`).data("analytics");
            let video_title = $(this).attr("title");
            // gtag("event", "click", {
            //   event_category: "Video Ended",
            //   event_label: `${hotspot} - ${video_title}`,
            // });
          });
        });
      } else {
        // if item type is image/file, get the image
        let featured_item_image = $(item).attr("data-img");
        // if item type is image/file, set the image
        $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media img`
        ).attr("src", featured_item_image);
      }
    } else {
      // when a modal is opened, get the featured item type
      let featured_item_type = $(
        `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block`
      ).attr("data-item-type");

      if (featured_item_type == "video") {
        // set the featured video player id to featured-video, this is used for the video player initialization with videojs
        $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video`
        ).attr("id", "featured-video");

        // if featured item type is video, get the poster and video source
        let featured_item_video_poster = $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video`
        ).attr("data-poster");
        let featured_item_video_mp4 = $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video source.mp4`
        ).attr("data-mp4");

        // if featured item type is video, set the poster and video source
        $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video`
        ).attr("poster", featured_item_video_poster);

        // if the mp4 source exists, set the src
        if (featured_item_video_mp4) {
          $(
            `#${modal_id} .helios-modal-container__featured .column-block .column-block__media video source.mp4`
          ).attr("src", featured_item_video_mp4);
        }

        // Clear Featured Item Video ID
        let featured_item_video_id = "";

        // If the modal has thumbnails
        if (
          !$(
            `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails`
          ).length
        ) {
          // If video is a single item, set a different id for videojs featured-video specific to the modal id
          featured_item_video_id = `${modal_id}-featured-video`;
          $(
            `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block .column-block__media video`
          ).attr("id", featured_item_video_id);
        } else {
          featured_item_video_id = "featured-video";
        }

        // If the video is a single item, initialize the video player for that item
        if (!videojs.players[featured_item_video_id]) {
          var video_player = videojs(featured_item_video_id, {}, function () {
            this.on("ended", function () {
              let hotspot = $(
                `#${modal_id}.helios-modal-open .helios-modal-container__title h4`
              ).text();
              let video_title = $(this).attr("title");
              if (analytics_debug) {
                console.log(`${hotspot} - Video Ended - ${video_title}`);
              }
              if (typeof gtag !== "undefined") {
                // gtag("event", "click", {
                //   event_category: "Video Ended",
                //   event_label: `${hotspot} - ${video_title}`,
                // });
              }
            });
          });
        }
      } else {
        // if featured item type is image/file, get the image
        let featured_item_image = $(
          `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block`
        ).attr("data-img");
        // if featured item type is image/file, set the image
        $(
          `#${modal_id} .helios-modal-container__featured .column-block .column-block__media img`
        ).attr("src", featured_item_image);
      }
    }
  }

  function helios_modal_load_thumbnails(modal_id) {
    // set all of the thumbnail background images when the modal is opened
    $(
      `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails .column-block`
    ).each(function (i, obj) {
      // Add support for thumbnails if they exist
      const data_thumb = $(this).attr("data-thumbnail");
      $(this).css("background-image", "url(" + (data_thumb ? data_thumb : $(this).attr("data-img")) + ")");
    });
  }

  function helios_modal_event_listeners(modal_id) {
    // add the select menu onchange event listener when the modal is opened to handle any and all asset/file swapping based on the chosen language
    helios_modal_selectmenu(modal_id);

    helios_modal_video(modal_id);

    helios_modal_link(modal_id);

    // when a thumbnail is clicked, update the featured item and set the thumbnail to active
    $(
      `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails .column-block`
    ).on("click", function (e) {
      e.preventDefault();
      if (!$(this).hasClass("active")) {
        helios_modal_update_featured(modal_id, this);
        $(
          `#${modal_id}.helios-modal-open .helios-modal-container__inner`
        ).animate({ scrollTop: 0 }, 400);
      }
    });

    // when a thumbnail is clicked, update the featured item and set the thumbnail to active
    $(
      `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails .column-block`
    ).keypress(function (e) {
      if (e.which == 13 && !$(this).hasClass("active")) {
        helios_modal_update_featured(modal_id, this);
        $(
          `#${modal_id}.helios-modal-open .helios-modal-container__inner`
        ).animate({ scrollTop: 0 }, 400);
      }
    });
  }

  function helios_modal_update_featured(modal_id, item) {
    // get the featured item container
    let stage = $(
      `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block`
    );
    // get the clicked thumbnail
    let active_item = $(item);
    // empty the featured item so we can add the contents of the clicked thumbnail
    stage.empty();
    // console.log('update');
    let embed_check = $(active_item);
    stage.html(active_item.html());

    // since all of the column blocks have a tabindex for tabbing, remove it from the stage everytime because we don't want users tabbing to that div
    stage.removeAttr("tabindex");
    // always remove the thumbnail active class before setting it
    $(
      `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails .column-block`
    ).removeClass("active");
    $(active_item).addClass("active");
    // load featured image assets/media.
    helios_modal_load_featured(modal_id, item);
    // add selectmenu event listeners
    helios_modal_selectmenu(modal_id);
    // add video event listeners
    helios_modal_video(modal_id);

    helios_modal_link(modal_id);
  }

  // reset the featured item to the first item in the thumbnail list when the user closes the modal

  function helios_modal_reset(modal_id) {
    if (videojs.players["featured-video"]) {
      videojs("featured-video").dispose();
    }
    // get the featured item container
    let stage = $(
      `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block`
    );
    // get the first item in the thumbnail list
    let active_item = $(
      `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails .column-block`
    ).first();
    // only set the stage from the first thumbnail item if it isn't already the featured item
    if (
      $(`#${modal_id}.helios-modal-open .helios-modal-container__thumbnails`)
        .length
    ) {
      stage.empty();
      stage.html(active_item.html());
      $(
        `#${modal_id}.helios-modal-open .helios-modal-container__thumbnails .column-block`
      ).removeClass("active");
      $(active_item).addClass("active");
    }
  }

  function helios_modal_selectmenu(modal_id) {
    // on select menu change
    $(".column-block__content select").on("change", function () {
      // get the featured item media column
      let stage = $(
        `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block__media`
      );
      // get the featured item, item type
      let stage_type = $(
        `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block`
      ).attr("data-item-type");
      // set the active item to the seleced option
      let active_item = this.value;
      let selected = $(this).find("option:selected");
      // get the selected option type
      let active_item_type = selected.data("option-type");
      if (active_item_type == "embed") {
        // if option type is embed, just replace the entire media column with its contents
        stage.empty();
        stage.html(active_item);
      } else if (active_item_type == "file") {
        // if the option type is file, just replace the href of the download button with the new file
        $(
          `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block__content .btn`
        ).attr("href", active_item);
      } else {
        // if the option type is video (url/file), get the poster image from the featured image column-block
        let video_poster = $(
          `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block`
        ).data("img");
        let active_item_mp4 = selected.data("mp4");
        let active_item_webm = selected.data("webm");
        // empty the media column and replace its conetns with an html5 video player, the src of the video is grabbed from the selected option
        stage.empty();
        if (active_item_webm) {
          stage.html(
            `<video poster="${video_poster}" controls webkit-playsinline class="video-js" id="featured-video"><source src="${active_item_webm}" class="webm" type="video/webm"><source src="${active_item_mp4}" class="mp4" type="video/mp4">Your browser does not support the video tag.</video>`
          );
        } else {
          stage.html(
            `<video poster="${video_poster}" controls webkit-playsinline class="video-js" id="featured-video"><source src="${active_item_mp4}" class="mp4" type="video/mp4">Your browser does not support the video tag.</video>`
          );
        }
        var video_player = videojs("featured-video", {}, function () {
          this.on("ended", function () {
            let hotspot = $(
              `#${modal_id}.helios-modal-open .helios-modal-container__title h4`
            ).text();
            let video_title = $(this).attr("title");

            // gtag("event", "click", {
            //   event_category: "Video Ended",
            //   event_label: `${hotspot} - ${video_title}`,
            // });
          });
        });
      }
    });
  }

  function helios_modal_video(modal_id) {
    if (modal_id !== "helios-modal-site-gate") {
      $(`#${modal_id}.helios-modal-open .vjs-big-play-button`).on(
        "click",
        function (e) {
          e.preventDefault();
          let video = this;
          let hotspot = $(`#${modal_id}.helios-modal-open`).data("analytics");
          let video_title = $(video).siblings("video").attr("title");
          $(video).fadeOut();
          setTimeout(function () {
            $(video).siblings("video").get(0).play();
          }, 300);
          // gtag("event", "click", {
          //   event_category: "Video Play",
          //   event_label: `${hotspot} - ${video_title}`,
          // });
        }
      );
    }
  }

  function helios_modal_link(modal_id) {
    $(`#${modal_id}.helios-modal-open .helios-modal-container__featured a`).on(
      "click",
      function () {
        let hotspot = $(`#${modal_id}.helios-modal-open`).data("analytics");
        let link_title;
        let link_text = $(this).text();
        if ($(this).hasClass("download")) {
          link_title = $(this).attr("title");
          // gtag("event", "click", {
          //   event_category: "File Download",
          //   event_label: `${hotspot} - ${link_title}`,
          // });
        } else if ($(this).hasClass("btn") && !$(this).hasClass("download")) {
          link_text = $(
            `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block__content h2`
          ).text();
          // gtag("event", "click", {
          //   event_category: "Link",
          //   event_label: `${hotspot} - ${link_text}`,
          // });
        } else {
          link_text = $(
            `#${modal_id}.helios-modal-open .helios-modal-container__featured .column-block__content h2`
          ).text();
          // gtag("event", "click", {
          //   event_category: "Link",
          //   event_label: `${hotspot} - ${link_text}`,
          // });
        }
      }
    );
  }

  /* End: Modal */

  /* Start: Cookie Notice */

  let helios_user_cookie_notice = $("#helios-cookie-notice");
  let helios_user_cookie_button = $("#accept-cookies");
  let helios_user_cookie_name = $(helios_user_cookie_notice).data(
    "cookie-name"
  );
  let helios_user_cookie_value = $(helios_user_cookie_notice).data(
    "cookie-value"
  );
  let helios_user_cookie_expiration = $(helios_user_cookie_notice).data(
    "cookie-duration"
  );

  if (get_cookie(helios_user_cookie_name)) {
    $(helios_user_cookie_notice).hide();
  } else {
    $(helios_user_cookie_notice).show();
  }

  $(helios_user_cookie_button).on("click", function (e) {
    e.preventDefault();
    set_cookie(
      helios_user_cookie_name,
      Boolean(helios_user_cookie_value),
      parseInt(helios_user_cookie_expiration)
    );
    $(helios_user_cookie_notice).hide();
  });

  /* End: Cookie Notice */

  /* Start: Site Announcement */

  let helios_announcement = $("#helios-announcement");
  let helios_announcement_cookie_name =
    $(helios_announcement).data("cookie-name");
  let helios_announcement_cookie_value =
    $(helios_announcement).data("cookie-value");
  let helios_announcement_cookie_expiration =
    $(helios_announcement).data("cookie-name");

  if (get_cookie(helios_announcement_cookie_name)) {
    $(helios_announcement).hide();
  } else {
    $(helios_announcement).show();
  }

  $(".helios-announcement-wrapper .helios-exit__btn").on("click", function (e) {
    e.preventDefault();
    set_cookie(
      helios_announcement_cookie_name,
      Boolean(helios_announcement_cookie_value),
      parseInt(helios_announcement_cookie_expiration)
    );
    $(helios_announcement).hide();
    if (is_fixed(helios_header)) {
      helios_announcement_position();
      helios_nav_position();
    }
  });

  function helios_announcement_position() {
    if ($(helios_announcement).is(":visible") && is_fixed(helios_header)) {
      $(".helios-announcement-wrapper").css("position", "fixed");
      $(helios_header).css("top", $(helios_announcement).outerHeight());
    } else {
      $(helios_header).removeAttr("style");
    }
  }

  if ($(helios_announcement).is(":visible")) {
    helios_announcement_position();
    let helios_announcement_resize_timer;
    $(window).on("resize", function (e) {
      clearTimeout(helios_announcement_resize_timer);
      helios_announcement_resize_timer = setTimeout(function () {
        helios_announcement_position();
      }, 250);
    });
  }

  /* End: Site Announcement */

  /* Start: Fixed Navigation */

  let helios_content_padding = 0;

  function helios_nav_position() {
    if ($(helios_announcement).is(":visible") && is_fixed(helios_header)) {
      $("#content").css(
        "padding-top",
        $(helios_header).outerHeight() +
          $(helios_announcement).outerHeight() +
          helios_content_padding
      );
    } else if (is_fixed(helios_header)) {
      $("#content").css(
        "padding-top",
        $(helios_header).outerHeight() + helios_content_padding - 1
      );
    } else {
      $("#content").removeAttr("style");
    }
  }

  if (is_fixed(helios_header)) {
    helios_nav_position();
    let helios_nav_resize_timer;
    $(window).on("resize", function (e) {
      clearTimeout(helios_nav_resize_timer);
      helios_nav_resize_timer = setTimeout(function () {
        helios_nav_position();
      }, 250);
    });
  }

  /* End: Fixed Navigation */

  /* Start: Site Gate */

  let helios_site_gate = $("#helios-modal-site-gate");
  let helios_site_gate_cookie_name = $(helios_site_gate).data("cookie-name");
  let helios_site_gate_cookie_value = $(helios_site_gate).data("cookie-value");
  let helios_site_gate_cookie_expiration =
    $(helios_site_gate).data("cookie-duration");

  let site_gate_video = document.getElementById("site-gate-video");
  let site_gate_video_player;

  function closeSiteGate() {
    helios_modal_exit("helios-modal-site-gate");
    $("#header").removeAttr("style");
    $(".helios-modal-overlay").removeClass("site-gate-overlay");
    bodyScrollLock.clearAllBodyScrollLocks();
    if (site_gate_video) {
      site_gate_video_player.pause();
    }
    if (helios_site_gate_cookie_name) {
      set_cookie(
        helios_site_gate_cookie_name,
        Boolean(helios_site_gate_cookie_value),
        parseInt(helios_site_gate_cookie_expiration)
      );
    }
  }

  $("#sitegate-skip").on("click", function () {
    closeSiteGate();
  });

  if (
    $("#helios-modal-site-gate").length &&
    !get_cookie(helios_site_gate_cookie_name)
  ) {
    helios_modal_enter("helios-modal-site-gate");
    $("#header").css("zIndex", 9999);
    $(".helios-modal-overlay").addClass("site-gate-overlay");

    if (site_gate_video) {
      site_gate_video_player = videojs(
        "site-gate-video",
        { controls: true },
        function () {
          this.on("ended", function () {
            setTimeout(function () {
              closeSiteGate();
            }, 150);

            // gtag("event", "click", {
            //   event_category: "Video Ended",
            //   event_label: `Sizzle Video`,
            // });
          });
        }
      );

      setTimeout(function () {
        site_gate_video_player.play();

        // gtag("event", "click", {
        //   event_category: "Video Play",
        //   event_label: `Sizzle Video`,
        // });
      }, 750);

      let volume = false;
      $(".site-gate-video-volume").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("volume");
        site_gate_video_player.muted(volume);
        volume = !volume;
      });

      $("#helios-modal-site-gate .vjs-mute-control").on("click", function () {
        if ($(".site-gate-video-volume").hasClass("volume")) {
          $(".site-gate-video-volume").removeClass("volume");
          volume = false;
        } else {
          $(".site-gate-video-volume").addClass("volume");
          volume = true;
        }
      });
    }

    if ($(".helios-modal-open").length < 2) {
      let targetElement = document.getElementById("helios-modal-site-gate");
      bodyScrollLock.disableBodyScroll(targetElement);
    }
  }

  /* End: Site Gate */ 

  /* Start: Welcome Modal */
  if (
    $("#helios-welcome-modal").length 
    && !get_cookie("wp-helios-welcome-modal")
  ) {
    let welcomeDelay = "7000";
    if (window.innerWidth <= 1000) {
      welcomeDelay = "2000";
    }
      setTimeout(() => {
        helios_modal_enter("helios-welcome-modal");
        set_cookie("wp-helios-welcome-modal", "wp-has-been-welcomed", 30);
        bodyScrollLock.disableBodyScroll("#helios-welcome-modal");
      }, welcomeDelay);
  }

  $(".welcome-modal-close").on('click', function (e){
    e.preventDefault();
    helios_modal_exit("helios-welcome-modal");
    bodyScrollLock.clearAllBodyScrollLocks();
  });
  /* End: Welcome Modal */

  /* Start: IE11 Browser Detection */

  if (!!window.MSInputMethodContext && !!document.documentMode) {
    let root = document.documentElement;
    root.classList.add("legacy");
  }

  /* End: IE11 Browser Detection */
});
